export const dateFormatConfig: Record<string, string> = {
    dayMonthYearFormat:"DD-MM-YYYY",
    date: "DD.MM.YYYY",
  };